export default __webpack_public_path__ + "static/media/snowswap-snow-logo.04769faa.svg";